export const CHAIN_ID_ETH = 1;
export const CHAIN_ID_BSC = 56;
export const CHAIN_ID_POLYGON = 137;
export const CHAIN_ID_AVAX_C = 43114;
export const CHAIN_ID_ARBITRUM = 42161;
export const CHAIN_ID_OPTIMISM = 10;
export const CHAIN_ID_BASE = 8453;
export const CHAIN_ID_SONIC = 146;
export const CHAIN_ID_BERA = 80094;
export const CHAIN_ID_SOLANA = -896789948;
export const CHAIN_ID_TON = -1141272988;
export const CHAIN_ID_TRON = 728126428;
export const CHAIN_ID_SUI = 114247; // "sui".hashCode()

export const NATIVE_ASSET_ADDRESS = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
export const ZERO_ADDRESS_TRON = "T9yD14Nj9j7xAB4dbGeiX9h8unkKHxuWwb";
export const SUNSWAP_ROUTER = "TFVisXFaijZfeyeSjCEVkHfex7HGdTxzF9";
export const WSOL = "So11111111111111111111111111111111111111112";
export const NATIVE_ADDRESS_TON = "EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c";
export const REFERRER_ADDRESS = "0xf919bFA27Db54cC1D397b6b9157bdF36e98C340E";

export const chainNames = {
  [CHAIN_ID_ETH]: "Ethereum",
  [CHAIN_ID_BSC]: "BNB Chain",
  [CHAIN_ID_POLYGON]: "Polygon",
  [CHAIN_ID_AVAX_C]: "Avalanche C-Chain",
  [CHAIN_ID_ARBITRUM]: "Arbitrum",
  [CHAIN_ID_OPTIMISM]: "Optimism",
  [CHAIN_ID_BASE]: "Base",
  [CHAIN_ID_SONIC]: "Sonic",
  [CHAIN_ID_BERA]: "Berachain",
  [CHAIN_ID_SOLANA]: "Solana",
  [CHAIN_ID_TON]: "Toncoin",
  [CHAIN_ID_TRON]: "Tron",
  [CHAIN_ID_SUI]: "Sui",
};

export const chainNamesShort = {
  [CHAIN_ID_ETH]: "ETH",
  [CHAIN_ID_BSC]: "BSC",
  [CHAIN_ID_POLYGON]: "POL",
  [CHAIN_ID_AVAX_C]: "AVAXC",
  [CHAIN_ID_ARBITRUM]: "ARB",
  [CHAIN_ID_OPTIMISM]: "OP",
  [CHAIN_ID_BASE]: "BASE",
  [CHAIN_ID_SONIC]: "S",
  [CHAIN_ID_BERA]: "BERA",
  [CHAIN_ID_SOLANA]: "SOL",
  [CHAIN_ID_TON]: "TON",
  [CHAIN_ID_TRON]: "TRX",
  [CHAIN_ID_SUI]: "SUI",
};

export const nativeAssetTicker = {
  [CHAIN_ID_ETH]: "ETH",
  [CHAIN_ID_BSC]: "BNB",
  [CHAIN_ID_POLYGON]: "POL",
  [CHAIN_ID_AVAX_C]: "AVAX",
  [CHAIN_ID_ARBITRUM]: "ETH",
  [CHAIN_ID_OPTIMISM]: "ETH",
  [CHAIN_ID_BASE]: "ETH",
  [CHAIN_ID_SONIC]: "S",
  [CHAIN_ID_BERA]: "BERA",
  [CHAIN_ID_SOLANA]: "SOL",
  [CHAIN_ID_TON]: "TON",
  [CHAIN_ID_TRON]: "TRX",
  [CHAIN_ID_SUI]: "SUI",
};

export const evmRpcUrlByChain = {
  [CHAIN_ID_ETH]: "https://mainnet.infura.io/v3/b6bf7d3508c941499b10025c0776eaf8",
  [CHAIN_ID_BSC]: "https://bsc-dataseed.binance.org",
  [CHAIN_ID_POLYGON]: "https://polygon-mainnet.infura.io/v3/b6bf7d3508c941499b10025c0776eaf8",
  [CHAIN_ID_AVAX_C]: "https://avalanche-mainnet.infura.io/v3/b6bf7d3508c941499b10025c0776eaf8",
  [CHAIN_ID_ARBITRUM]: "https://arbitrum-mainnet.infura.io/v3/b6bf7d3508c941499b10025c0776eaf8",
  [CHAIN_ID_OPTIMISM]: "https://optimism-mainnet.infura.io/v3/b6bf7d3508c941499b10025c0776eaf8",
  [CHAIN_ID_BASE]: "https://mainnet.base.org",
  [CHAIN_ID_SONIC]: "https://rpc.soniclabs.com",
  [CHAIN_ID_BERA]: "https://rpc.berachain.com",
};

export const gasStep = {
  [CHAIN_ID_ETH]: 0.01,
  [CHAIN_ID_BSC]: 0.1,
  [CHAIN_ID_POLYGON]: 1,
  [CHAIN_ID_AVAX_C]: 1,
  [CHAIN_ID_ARBITRUM]: 0.001,
  [CHAIN_ID_OPTIMISM]: 0.0001,
  [CHAIN_ID_BASE]: 0.0001,
  [CHAIN_ID_SONIC]: 1,
};

export const explorerUrl = {
  "all": "https://blockscan.com",
  [CHAIN_ID_ETH]: "https://etherscan.io",
  [CHAIN_ID_BSC]: "https://bscscan.com",
  [CHAIN_ID_POLYGON]: "https://polygonscan.com",
  [CHAIN_ID_AVAX_C]: "https://snowtrace.io",
  [CHAIN_ID_ARBITRUM]: "https://arbiscan.io",
  [CHAIN_ID_OPTIMISM]: "https://optimistic.etherscan.io",
  [CHAIN_ID_BASE]: "https://basescan.org",
  [CHAIN_ID_SONIC]: "https://sonicscan.org",
};

export const exchangeNames = {
  binance: "Binance",
  "binance-futures": "Binance Futures",
  huobi: "HTX",
  "huobi-futures": "HTX Futures",
  okx: "OKX",
  "okx-futures": "OKX Futures",
  kucoin: "Kucoin",
  "kucoin-futures": "Kucoin Futures",
  mexc: "MEXC",
  "mexc-futures": "MEXC Futures",
  gate: "Gate",
  "gate-futures": "Gate Futures",
  bybit: "Bybit",
  "bybit-futures": "Bybit Futures",
  bitget: "Bitget",
  "bitget-futures": "Bitget Futures",
  upbit: "Upbit",
  backpack: "Backpack",
  "backpack-futures": "Backpack Futures",
  "hyperliquid": "Hyperliquid Spot",
  "hyperliquid-futures": "Hyperliquid",
};

export const AUTH_HEADER_PREFIX = "arb-trader-coinmatic";

export const NETWORK_LOGO = {
  [CHAIN_ID_ETH]: "/img/chains/ethereum.svg",
  [CHAIN_ID_BSC]: "/img/chains/bsc.svg",
  [CHAIN_ID_POLYGON]: "/img/chains/polygon.svg",
  [CHAIN_ID_ARBITRUM]: "/img/chains/arbitrum.svg",
  [CHAIN_ID_OPTIMISM]: "/img/chains/optimism.svg",
  [CHAIN_ID_AVAX_C]: "/img/chains/avalanche.svg",
  [CHAIN_ID_BASE]: "/img/chains/base.svg",
  [CHAIN_ID_SONIC]: "/img/chains/sonic.svg",
  [CHAIN_ID_SOLANA]: "https://coin-images.coingecko.com/coins/images/4128/large/solana.png",
  [CHAIN_ID_TON]: "https://coin-images.coingecko.com/coins/images/17980/large/ton_symbol.png",
  [CHAIN_ID_TRON]: "https://coin-images.coingecko.com/coins/images/1094/large/tron-logo.png",
  [CHAIN_ID_SUI]: "/img/chains/sui.svg",
};

export const EXCHANGE_LOGO = {
  binance: "/img/exchanges/binance.svg",
  "binance-futures": "/img/exchanges/binance.svg",
  huobi: "/img/exchanges/huobi.svg",
  "huobi-futures": "/img/exchanges/huobi.svg",
  kucoin: "/img/exchanges/kucoin.svg",
  "kucoin-futures": "/img/exchanges/kucoin.svg",
  okx: "/img/exchanges/okx.svg",
  "okx-futures": "/img/exchanges/okx.svg",
  mexc: "/img/exchanges/mexc.svg",
  "mexc-futures": "/img/exchanges/mexc.svg",
  gate: "/img/exchanges/gate.svg",
  "gate-futures": "/img/exchanges/gate.svg",
  bybit: "/img/exchanges/bybit.svg",
  "bybit-futures": "/img/exchanges/bybit.svg",
  upbit: "/img/exchanges/upbit.svg",
  bitget: "/img/exchanges/bitget.svg",
  "bitget-futures": "/img/exchanges/bitget.svg",
  backpack: "/img/wallets/backpack.png",
  "backpack-futures": "/img/wallets/backpack.png",
  "hyperliquid": "/img/exchanges/hyperliquid.svg",
  "hyperliquid-futures": "/img/exchanges/hyperliquid.svg",
};


export const dexScreenerChainIds = {
  [CHAIN_ID_ETH]: "ethereum",
  [CHAIN_ID_BSC]: "bsc",
  [CHAIN_ID_POLYGON]: "polygon",
  [CHAIN_ID_AVAX_C]: "avalanche",
  [CHAIN_ID_ARBITRUM]: "arbitrum",
  [CHAIN_ID_OPTIMISM]: "optimism",
  [CHAIN_ID_BASE]: "base",
  [CHAIN_ID_SONIC]: "sonic",
  [CHAIN_ID_SOLANA]: "solana",
  [CHAIN_ID_TON]: "ton",
  [CHAIN_ID_TRON]: "tron",
  [CHAIN_ID_SUI]: "sui",
};

export const dexToolsChainIds = {
  [CHAIN_ID_ETH]: "ether",
  [CHAIN_ID_BSC]: "bnb",
  [CHAIN_ID_POLYGON]: "polygon",
  [CHAIN_ID_AVAX_C]: "avalanche",
  [CHAIN_ID_ARBITRUM]: "arbitrum",
  [CHAIN_ID_OPTIMISM]: "optimism",
  [CHAIN_ID_BASE]: "base",
  [CHAIN_ID_SONIC]: "sonic",
  [CHAIN_ID_SOLANA]: "solana",
  [CHAIN_ID_TON]: "ton",
  [CHAIN_ID_TRON]: "tron",
  [CHAIN_ID_SUI]: "sui",
};

export const geckoTerminalChainIds = {
  [CHAIN_ID_ETH]: "eth",
  [CHAIN_ID_BSC]: "bsc",
  [CHAIN_ID_POLYGON]: "polygon_pos",
  [CHAIN_ID_AVAX_C]: "avax",
  [CHAIN_ID_ARBITRUM]: "arbitrum",
  [CHAIN_ID_OPTIMISM]: "optimism",
  [CHAIN_ID_BASE]: "base",
  [CHAIN_ID_SONIC]: "sonic",
  [CHAIN_ID_SOLANA]: "solana",
  [CHAIN_ID_TON]: "ton",
  [CHAIN_ID_TRON]: "tron",
  [CHAIN_ID_SUI]: "sui-network",
};


export const USDT_TOKEN: Record<string, { address: string, symbol: string, decimals: number }> = {
  [CHAIN_ID_ETH]: { address: "0xdAC17F958D2ee523a2206206994597C13D831ec7", symbol: "USDT", decimals: 6 },
  [CHAIN_ID_BSC]: { address: "0x55d398326f99059fF775485246999027B3197955", symbol: "USDT", decimals: 18 },
  [CHAIN_ID_POLYGON]: { address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F", symbol: "USDT", decimals: 6 },
  [CHAIN_ID_AVAX_C]: { address: "0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7", symbol: "USDT", decimals: 6 },
  [CHAIN_ID_ARBITRUM]: { address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9", symbol: "USDT", decimals: 6 },
  [CHAIN_ID_OPTIMISM]: { address: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58", symbol: "USDT", decimals: 6 },
  [CHAIN_ID_BASE]: { address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913", symbol: "USDC", decimals: 6 },
  [CHAIN_ID_SONIC]: { address: "0x29219dd400f2Bf60E5a23d13Be72B486D4038894", symbol: "USDC", decimals: 6 },
  [CHAIN_ID_SOLANA]: { address: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB", symbol: "USDT", decimals: 6 },
  [CHAIN_ID_TON]: { address: "EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs", symbol: "USDT", decimals: 6 },
  [CHAIN_ID_TRON]: { address: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t", symbol: "USDT", decimals: 6 },
  [CHAIN_ID_SUI]: { address: "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC", symbol: "USDC", decimals: 6 },
};

export const MULTICALL3_CONTRACT = {
  [CHAIN_ID_ETH]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [CHAIN_ID_BSC]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [CHAIN_ID_POLYGON]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [CHAIN_ID_AVAX_C]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [CHAIN_ID_ARBITRUM]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [CHAIN_ID_OPTIMISM]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [CHAIN_ID_BASE]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [CHAIN_ID_SONIC]: "0xcA11bde05977b3631167028862bE2a173976CA11",
  [CHAIN_ID_TRON]: "TEazPvZwDjDtFeJupyo7QunvnrnUjPH8ED",
  [CHAIN_ID_BERA]: "0xcA11bde05977b3631167028862bE2a173976CA11",
};

export const stableCoinSymbols = ["USDT", "USDC", "DAI", "FDUSD", "USD"];

export const HEARTBEAT_INTERVAL = 5000;

export const walletNames = {
  phantom: "Phantom",
  solflare: "Solflare",
  backpack: "Backpack",
  okx: "OKX",
};

export const walletIcons = {
  phantom: "/img/wallets/phantom.svg",
  solflare: "/img/wallets/solflare.jpg",
  backpack: "/img/wallets/backpack.png",
  okx: "/img/wallets/okx.svg",
};
